import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import type { VideoItem } from '@/mocks/videos';

interface VideoCardProps {
  video: VideoItem;
}

export default function VideoCard({ video }: VideoCardProps) {
  const { t } = useTranslation();

  return (
    <Link
      to={`/article/${video.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300"
    >
      {/* Image */}
      <div className="relative aspect-[3/4] overflow-hidden bg-background-100">
        <img
          src={video.image}
          alt={`${video.title} - 国产在线观看高清影视`}
          title={`${video.title} - 国产影视在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
        />
        {/* Overlay on hover */}
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-colors duration-300 flex items-center justify-center">
          <span className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-primary-500 text-background-50 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap">
            {t('videoCard.play')}
          </span>
        </div>
        {/* Badges */}
        <div className="absolute top-2 left-2 flex flex-col gap-1">
          {video.isNew && (
            <span className="px-2 py-0.5 text-xs font-medium bg-accent-500 text-background-50 rounded-md whitespace-nowrap">
              NEW
            </span>
          )}
          {video.isHot && !video.isNew && (
            <span className="px-2 py-0.5 text-xs font-medium bg-primary-500 text-background-50 rounded-md whitespace-nowrap">
              热播
            </span>
          )}
        </div>
        {/* Rating */}
        <div className="absolute top-2 right-2 bg-black/60 backdrop-blur-sm px-2 py-0.5 rounded-md flex items-center gap-1">
          <i className="ri-star-fill text-yellow-400 w-3 h-3 flex items-center justify-center text-xs"></i>
          <span className="text-xs text-white font-medium">{video.rating}</span>
        </div>
        {/* Episode count */}
        <div className="absolute bottom-2 right-2 bg-black/60 backdrop-blur-sm px-2 py-0.5 rounded-md">
          <span className="text-xs text-white">{video.episodes}</span>
        </div>
      </div>

      {/* Info */}
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-950 line-clamp-1 mb-1 group-hover:text-primary-500 transition-colors">
          {video.title}
        </h3>
        <p className="text-xs text-foreground-500 line-clamp-1 mb-2">{video.actors.slice(0, 2).join(' / ')}</p>
        <div className="flex items-center justify-between">
          <span className="text-xs text-foreground-400">{video.year}</span>
          <span className="text-xs text-foreground-400 flex items-center gap-1">
            <i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i>
            {video.views}
          </span>
        </div>
      </div>
    </Link>
  );
}